import { useCallback, useMemo } from 'react'

import { useInView } from 'react-cool-inview'

import useTracker from 'Pods/Shared/Hooks/useTracker'

const CUSTOM_ATTRS = { customAttributes: { event_source: 'collections_hub' } }

export const LOCATION_BY_TYPE = {
  cg: '3d-collections',
  print: '3d-print-collections',
}

function usePromoTracking({ id, name, creative, slot, collectionType }) {
  const { trackEvent } = useTracker()

  const eventData = useMemo(() => ({
    promotion_id: id,
    promotion_name: name,
    creative_name: 'collection_card',
    creative_slot: creative,
    location_id: LOCATION_BY_TYPE[collectionType] || '',
    index: Number(slot),
  }), [id, name, creative, slot, collectionType])

  const { observe } = useInView({
    threshold: 0.5,
    delay: 1000,
    unobserveOnEnter: true,
    onEnter: () => trackEvent('view_promotion', eventData, CUSTOM_ATTRS),
  })

  const handleSelect = useCallback(() => {
    trackEvent('select_promotion', eventData, CUSTOM_ATTRS)
  }, [trackEvent, eventData])

  return { ref: observe, handleSelect }
}

export default usePromoTracking
